const generateRecipientTableCSV = ({ dataType, data }) => {
  const isTopic = dataType === 'topic';
  const isMessage = dataType === 'message';

  const headers = [
    'AMS ID',
    'M1 ID',
    'First Name',
    'Last Name',
    isMessage ? 'Email Delivery' : 'Email',
    isMessage ? 'Text Delivery' : 'Phone',
    ...(isTopic ? ['Email Opted-In', 'Text Opted-In'] : []),
  ];
  return [
    headers,
    ...data.map(_ => [
      _.memberKeyNumeric,
      _.NRDS,
      _.firstName,
      _.lastName,
      isMessage ? _.contactMethods[0] : _.email,
      isMessage ? _.contactMethods[1] : _.phone,
      ...(isTopic
        ? [
            _.contactMethods?.[0] ? 'Yes' : 'No',
            _.contactMethods?.[1] ? 'Yes' : 'No',
          ]
        : []),
    ]),
  ];
};

export default generateRecipientTableCSV;
